import { Skeleton } from 'antd';

// Custom data source to show skeletons inside table rows
const skeletonData = Array.from({ length: 10 }, (_, index) => ({
  serial: <Skeleton active title={false} paragraph={{ rows: 1, width: "50%" }} />,
  name: <><Skeleton.Button active shape="circle" /><Skeleton active title={false} paragraph={{ rows: 1, width: "80%" }} /></>,
  phoneNumber: <Skeleton active title={false} paragraph={{ rows: 1, width: "50%" }} />,
  gender: <Skeleton active title={false} paragraph={{ rows: 1, width: "50%" }} />,
  joiningDate: <Skeleton active title={false} paragraph={{ rows: 1, width: "50%" }} />,
  verifyImage: <Skeleton active title={false} paragraph={{ rows: 1, width: "50%" }} />,
  isVerified: <Skeleton active title={false} paragraph={{ rows: 1, width: "50%" }} />,
  status: <Skeleton active title={false} paragraph={{ rows: 1, width: "50%" }} />,
  actions: (
    <>
      <Skeleton.Button active shape="square" />
    </>
  ),
}));

// Exporting the skeletonData
export { skeletonData };
